<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<div class="main-div">
    <div class="left-div" />

    <div class="right-div"
    >
        <div class="onediv">
            <p>3</p>
        </div>
        <div class="text1">
            <p>VFX, 3D Environment & Prop Designers</p>
        </div>
        <div class="text2-div">
            <p>
                Realism is about depth and effects. You don’t just create
                worlds, you make them real so that your audience doesn’t just
                wow at a flat image but gasps and trips. Your talent is to make
                them forget the difference between the real world and the
                imagined one.
                <br>
                <br>
                <span style="font-weight: 600;">
                    We’re building the future where your talents get truly
                    unleashed, where you don't get stuck creating walls and
                    doors, one vertex at a time but cities and planets. Learn
                    and participate.
                </span>
            </p>
        </div>
        <div class="button">
            <DesktopButton2 
            state = "Artists & Musicians"
            text1 = "Join Visual Art Governance Council"
            text2 = "(3D Seat)"
            text3 = 25
            TextColor = "white"
            TextColor2 = "white"
            BorderColorBefore = '0.093vh solid white'
            BorderColorAfter = '0.093vh solid aqua'
            TextColorAfter = 'black'
            AnimationColor = 'aqua'
             />
        </div>
    </div>
   
</div>

<style>
    p {
        margin: 0;
    }
    .right-div{
        height: 100vh;
        width: 177.778vh;
        background-image: url("/images/ArtistPage/section3.png");
        background-size: cover;
        background-position: center;
        font-family: "Orbitron";
        filter: grayscale(1);
        transition-duration:1.2s;
    }
    .right-div:hover{
        filter: grayscale(0);
    }
    .left-div {
        width: 6.481vh;
        height: 100vh;
        background-color: #faf7f6;
    }
    .main-div {
        height: 100vh;
        display: flex;
        position: relative;
    }
    .onediv {
        font-size: 55.556vh;
        color: #f4eeec;
        font-weight: 700;
        position: absolute;
        left: 14.259vh;
        opacity: 50%;
        top: 5.833vh;
    }
    .text1 {
        width: 83.426vh;
        font-size: 5.556vh;
        line-height: 5.556vh;
        color: white;
        font-weight: 700;
        position: absolute;
        left: 23.333vh;
        top: 37.13vh;
    }
    .text2-div{
        width: 57.685vh;
        height: 28.519vh;
        background-color: white;
        border-radius: 3.704vh;
        position: absolute;
        top: 51.019vh;
        left: 102.685vh;
        padding: 4.074vh;
        opacity: 0.9;
    }
    .text2-div p{
        font-size: 1.852vh ;
        font-weight: 400;
        line-height: 2.593vh ;
        color: #000000;
        letter-spacing: 0.12vh;
    }
    .button{
        position: absolute;
        top: 64.722vh;
        left: 29.815vh;
    }
</style>
